<script setup>
import { computed } from 'vue'
import { router } from '@inertiajs/vue3'
import Button from 'primevue/button'
import { trans } from 'laravel-vue-i18n'

const actions = computed(() => [
    { id: 'new-reservation', label: trans('dashboard.quick_new_reservation'), icon: 'pi pi-calendar-plus', action: () => router.visit(route('app.reservations')) },
    { id: 'new-form',        label: trans('dashboard.quick_new_form'),        icon: 'pi pi-th-large',      action: () => router.visit(route('app.forms')) },
    { id: 'contacts',        label: trans('dashboard.quick_contacts'),        icon: 'pi pi-users',          action: () => router.visit(route('contacts.index')) },
])
</script>

<template>
    <div class="grid grid-cols-2 gap-2.5">
        <Button
            v-for="a in actions"
            :key="a.id"
            :label="a.label"
            :icon="a.icon"
            text
            class="!justify-start !p-3.5 !rounded-[13px] border border-gray-100 dark:border-neutral-800 hover:!border-blue-300 dark:hover:!border-blue-700"
            @click="a.action()"
        />
    </div>
</template>
